import { isAfter, isBefore } from 'date-fns';

export function isDropExpired(showUntil: string): boolean {
  return !isBefore(new Date(), new Date(showUntil));
}

export function isDropCountdownPeriod(dropDate: string): boolean {
  return isBefore(new Date(), new Date(dropDate));
}

export function isDropLive(dropDate: string, showUntil: string): boolean {
  const now = new Date();
  return isAfter(now, new Date(dropDate)) && isBefore(now, new Date(showUntil));
}
